import React, { useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import ProductStarScore from "../../module/product-star-score";
import { useIntl } from "react-intl";
import ReactPaginate from 'react-paginate';
import { useEffect } from "react";
import { fetchReviewComments } from "../../../../../../api";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import { FormattedMessage } from "react-intl";
import { setZoomImagePopover } from "../../../../../../store/actions/pages/product";
import { useDispatch } from "react-redux";


const ReviewItemAvg = props =>{
    const { reviewItem, isBeautyMakeup } = props;
    const { avgScore, sizingRecommendation } = reviewItem;
    const intl = useIntl();

    let reviewData = [];
    let total = 0;
    if(sizingRecommendation){
        let large = sizingRecommendation?.tooLarge;
        let fit = sizingRecommendation?.goodFit;
        let small = sizingRecommendation?.tooSmall;
        total = (large + fit + small);
        let percentSmall = small / total;
        let percentFit = fit / total;
        let percentLarge = large / total;

        reviewData = [
            {
                id: 1,
                title: intl.formatMessage({ id: 'too_small' }),
                percent: Math.round(percentSmall * 100).toFixed(1)
            },
            {
                id: 2,
                title: intl.formatMessage({ id: 'ture_to_size' }),
                percent: Math.round(percentFit * 100).toFixed(1)
            },
            {
                id: 3,
                title: intl.formatMessage({ id: 'to_large' }),
                percent: Math.round(percentLarge * 100).toFixed(1)
            }
        ];
    }

    

    return <div className={classes.ReviewItemAvg}>
        <div className={classes.ReviewStar}>
            <span className={classes.Num}>{avgScore.toFixed(1)}</span>
            <ProductStarScore 
                className={classes.ProductStarScore} 
                starScore={avgScore}
            />
        </div>

        {
            // 美妆不显示百分比进度
            !isBeautyMakeup && sizingRecommendation && total > 0 && <>
                {
                    reviewData?.map((item,index) =>{
                        return <div className={classes.AvgItem} key={item.id+index}>
                            <div className={classes.Item1}><span>{item.title}</span></div>
                            <div className={classes.Item2}>
                                <span className={classes.Span1}>
                                    <span className={classes.Span2} style={{width:`${item.percent}%`}}></span>
                                </span>
                            </div>
                            <div className={classes.Item3}><span>{item.percent}%</span></div>
                        </div>
                    })
                }
            </>
        }
    </div>
}

const ReviewPaginate = props =>{
    const { itemPageCount, totalNum, changeReviewData, productId } = props;
    
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(()=>{
        const endOffset = itemOffset + itemPageCount;
        setPageCount(Math.ceil(totalNum / itemPageCount));
    },[]);

    const handlePageClick = async (event) => {
        const newOffset = (event.selected * itemPageCount) % totalNum;
        let response = await fetchReviewComments(productId,newOffset,itemPageCount).catch(()=>[]);
        if(response?.code === 200){
            changeReviewData(response?.result);
            setPageCount(Math.ceil(totalNum / itemPageCount));
            setItemOffset(newOffset);
        }
    };

    return <div className={classes.ReviewPaginate}>
        <ReactPaginate
            className={classes.PaginateItem}
            pageClassName={classes.normalClass}
            previousClassName={classes.normalClass}
            nextClassName={classes.normalClass}
            breakClassName={classes.normalClass}
            breakLabel={'...'}
            nextLabel=">"
            previousLabel="<"
            pageRangeDisplayed={2}
            onPageChange={handlePageClick}
            pageCount={pageCount}
            disabledClassName={classes.Disabled}
            activeClassName={classes.Active}
            pageLinkClassName={classes.LinkActive}
            breakLinkClassName={classes.LinkActive}
            previousLinkClassName={classes.LinkActive}
            nextLinkClassName={classes.LinkActive}
        />
    </div>
}

const ReviewContent = props =>{
    const { reviewData } = props;

    const intl = useIntl();

    const dispatch = useDispatch();

    const getName = (name) => {
        if (name && name.length > 2) {
            return name.replace(name.substr(1, name.length - 2), '***')
        }
        return name;
    }

    const getFittype = type => {
        let label = '-';
        switch (type) {
            case '1':
                label = intl.formatMessage({ id: 'to_large' });
                break;
            case '2':
                label = intl.formatMessage({ id: 'ture_to_size' });
                break;
            case '3':
                label = intl.formatMessage({ id: 'too_small' });
                break;
        }

        return label;
    }

    const zoomImageEvent = (image,images) =>{
        dispatch(setZoomImagePopover({image,images,prefix:`${IMAGE_GEEKO_LTD}/comment/medium`}));
    }

    return <div className={classes.ReviewContent}>
        {
            reviewData?.map((review,index)=>{
                return <div className={classes.ReviewItem} key={index}>
                    <div className={classes.First}>
                        <div className={classes.FirstItem}>
                            <span className={classes.Name}>{getName(review?.customerName)}</span>
                            <ProductStarScore starScore={review?.score} className={classes.Star} />

                            {
                                review.sizingRecommendation && <span className={classes.Clothes}><FormattedMessage id="overall_fit" defaultMessage="Overall Fit" /> : {getFittype(review.sizingRecommendation)}</span>
                            }
                        </div>
                        <div className={classes.Time}>{review?.createTime}</div>
                    </div>
        
                    <div className={classes.Second}>
                        <span>{review?.content}</span>
                    </div>
                    
                    {
                        review?.images?.length > 0 &&  <div className={classes.Third}>
                            {
                                review?.images.map((item,index)=>{
                                    return <div className={classes.ImageItem} key={index} onClick={()=>zoomImageEvent(item,review?.images)}>
                                        <img src={`${IMAGE_GEEKO_LTD}/comment/medium/${item}`} alt="Image" />
                                    </div>
                                })
                            }
                            
                        </div>
                    }

                    <div className={classes.Fourth}>
                        {
                            review?.height && <span className={classes.PreferenceItem}>
                                <span><FormattedMessage id="height" defaultMessage="Height" />:</span>
                                <span>{review?.height}</span>
                            </span>
                        }
                        
                        {
                            review?.weight && <span className={classes.PreferenceItem}>
                                <span><FormattedMessage id="weight" defaultMessage="Weight" />:</span>
                                <span>{review?.weight}</span>
                            </span>
                        }

                        {
                            review?.bust && <span className={classes.PreferenceItem}>
                                <span><FormattedMessage id="bust" defaultMessage="Bust" />:</span>
                                <span>{review?.bust}</span>
                            </span>
                        }

                        {
                            review?.waist && <span className={classes.PreferenceItem}>
                                <span><FormattedMessage id="waist" defaultMessage="Waist" />:</span>
                                <span>{review?.waist}</span>
                            </span>
                        }
                    </div>
                </div>
            })
        }
        
    </div>
}

const ReviewContainer = props =>{
    const { reviewItem } = props;
    const [reviewData, setReviewData] = useState(reviewItem?.comments?.slice(0, 3)); //当前reviewData


    return <div className={classes.ReviewContainer}>
        {
            reviewData?.length > 0 && <ReviewContent reviewData={reviewData} />
        }
        
        {
           reviewItem?.total > 3 && <React.Fragment>
                <ReviewPaginate 
                    itemPageCount={3} 
                    totalNum={reviewItem.total} 
                    changeReviewData={(data)=>setReviewData(data)} 
                    {...props}
                />
           </React.Fragment> 
        }
    </div>
}

const ProductReviews = props =>{
    useStyles(classes);
    const { productHooks, reviewItem } = props;
    const { selectedProduct, isBeautyMakeup } = productHooks;

    return <React.Fragment>
        {
            reviewItem?.total > 0 && <div className={classes.ProductReviews} id="commentbox">
                <div className={classes.ReviewTitle}>
                    <span><FormattedMessage id="customer_reviews" defaultMessage="Customer Reviews" /></span>
                    <span>({reviewItem?.total})</span>
                </div>
                
                <ReviewItemAvg {...props} isBeautyMakeup={isBeautyMakeup} />

                <ReviewContainer reviewItem={reviewItem} productId={selectedProduct?.id} />
            </div>
        }
    </React.Fragment>
}

export default ProductReviews;